module.exports = __webpack_public_path__ + "img/icon-zbf@2x.9de7c5b9.png";